import { UrlObject } from '../../../../types/__codegen__/sanity/graphql';
import { URLS } from '../../../../models/url/constants';

type ContactLinks = ReadonlyArray<{
  title: string;
  link: Readonly<UrlObject>;
  subtitle?: JSX.Element;
  description?: JSX.Element;
}>;

const CONTACT_US = 'Contact Us';

const otherInsuranceContactLinks = (): ContactLinks => [
  {
    link: {
      name: CONTACT_US,
      url: URLS.SALES.LIFE_INSURANCE_CONTACT_US,
    },
    title: 'Life Insurance',
  },
  {
    link: {
      name: CONTACT_US,
      url: URLS.SALES.LIFE_INSURANCE_CONTACT_US,
    },
    title: 'Income protection',
  },
  {
    link: {
      name: CONTACT_US,
      url: URLS.SALES.TRAVEL_INSURANCE_CONTACT_US,
    },
    title: 'Travel Insurance',
  },
  {
    link: {
      name: CONTACT_US,
      url: URLS.SALES.CAR_INSURANCE_CONTACT_US,
    },
    title: 'Car Insurance',
  },
  {
    link: {
      name: CONTACT_US,
      url: URLS.SALES.HOME_INSURANCE_CONTACT_US,
    },
    title: 'Home Insurance',
  },
  {
    link: {
      name: CONTACT_US,
      url: URLS.SALES.PET_INSURANCE_CONTACT_US,
    },
    title: 'Pet Insurance',
  },
];

export default otherInsuranceContactLinks;
